import { User } from 'api/endpoints/users';
import BaseRepo from 'container/BaseRepo';
import { buildBadRequestApiError } from 'container/helpers/errors';
import { ApiResponseAsync } from 'container/models';
import { IExternalSystemsRepo } from 'container/services/externalSystemsRepo/IExternalSystemsRepo';
import { ExternalSystemsIssue } from 'types/externalSystemsIssues';

export class ExternalSystemsRepo
  extends BaseRepo
  implements IExternalSystemsRepo
{
  getIssuesReport = (user: User): ApiResponseAsync<ExternalSystemsIssue[]> => {
    const link = user._links?.['getExternalResourcesIssues'];
    if (!link)
      return Promise.resolve(
        buildBadRequestApiError(
          new Error('link "get external resources issues" is not available')
        )
      );

    return this.helpers.handleGet<ExternalSystemsIssue[]>(link.href);
  };
}
